export const LANGUAGE_CODES = {
  EN: "en",
  ES: "es",
};

export const LOCATIONS = {
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP: "top",
};

export const STATE_CODES = {
  ACTIVE: "active",
  DISABLED: "disabled",
  ERROR: "error",
  OK: "ok",
  WARNING: "warning",
};

export const STATE_THEMES = {
  DARK: "dark",
  LIGHT: "light",
  MEDIUM: "medium",
};

export const PALETTE_CODES = {
  GREEN: "green",
  GREEN_LIGHT: "green-light",
  MAIN: "main",
  MAIN_DARKEST: "main-darkest",
  MAIN_LIGHT: "main-light",
  OLIVE: "olive",
  ORANGE: "orange",
  RED: "red",
  RED_DARK: "red-dark",
  RED_LIGHT: "red-light",
};
